import type { ThunkAction } from 'redux-thunk';
import type { AnyAction } from 'redux';

import { fetchErrorMiddleware, fetchErrorMiddlewareMaybeJson } from 'middleware/fetchErrorMiddleware';
import { trackError } from 'helpers/ErrorUtils';
import { CHANGE_FOLLOW_COUNT, CHANGE_FOLLOW_STATUS, SET_CUSTOMER_FOLLOW_STATUS, SET_INFLUENCER_FOLLOWERS_COUNT } from 'constants/reduxActions';
import type { AppState } from 'types/app';
import { IDENTIFIER_TYPE_CUSTOMER_ID } from 'constants/influencerPages';
import { getInfluencerDetailsByIdentifier, getInfluencerFollowersStatus, updateInfluencerFollowingStatus } from 'apis/mafia/influencer';

export const setInfluencerFollowersCount = (count: number) => ({
  type: SET_INFLUENCER_FOLLOWERS_COUNT,
  count
});

export const changeFollowStatus = (status: boolean) => ({
  type: CHANGE_FOLLOW_STATUS,
  status
});

export const changeFollowCount = (status: boolean) => ({
  type: CHANGE_FOLLOW_COUNT,
  status
});

export const setCustomerFollowStatus = (status: boolean) => ({
  type: SET_CUSTOMER_FOLLOW_STATUS,
  status
});

export function fetchFollowCount(influencerId: string): ThunkAction<void, AppState, void, AnyAction> {
  return (dispatch, getState) => {
    const {
      cookies,
      environmentConfig: {
        api: { mafia }
      },
      url: { host }
    } = getState();
    const identifierType = IDENTIFIER_TYPE_CUSTOMER_ID;
    return getInfluencerDetailsByIdentifier(mafia, influencerId, identifierType, cookies, host)
      .then(fetchErrorMiddleware)
      .then((response: { details: { influencerFollowersCount: number } }) => {
        dispatch(setInfluencerFollowersCount(response.details.influencerFollowersCount));
      })
      .catch((e: Error) => {
        trackError('NON-FATAL', 'Could not fetch details for influencer.', e);
      });
  };
}

export function updateFollowStatus(influencerId: string, status: boolean): ThunkAction<void, AppState, void, AnyAction> {
  return (dispatch, getState) => {
    const {
      cookies,
      environmentConfig: {
        api: { mafia }
      }
    } = getState();
    dispatch(changeFollowStatus(!status));
    dispatch(changeFollowCount(!status));
    const requestBody = {
      influencerId: influencerId,
      isFollowing: !status
    };
    updateInfluencerFollowingStatus(mafia, requestBody, influencerId, cookies)
      .then(fetchErrorMiddlewareMaybeJson)
      .then((response: { status: string }) => {
        if (response.status === 'Failed') {
          dispatch(changeFollowStatus(status));
        }
      })
      .catch((e: Error) => {
        trackError('NON-FATAL', 'Could not update follow status .', e);
        dispatch(changeFollowStatus(status));
        dispatch(changeFollowCount(status));
      });
  };
}

export function fetchFollowStatus(influencerId: string): ThunkAction<void, AppState, void, AnyAction> {
  return (dispatch, getState) => {
    const {
      cookies,
      environmentConfig: {
        api: { mafia }
      }
    } = getState();
    getInfluencerFollowersStatus(mafia, influencerId, cookies)
      .then(fetchErrorMiddlewareMaybeJson)
      .then((response: { status: boolean }) => {
        dispatch(setCustomerFollowStatus(response.status));
      })
      .catch((e: Error) => {
        trackError('NON-FATAL', 'Could not fetch follow status .', e);
      });
  };
}
